export default __webpack_public_path__ + "static/media/background-music.5ea09bae.mp3";